const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}

const UNDERSCORE_ITALIC =
  /(^|[^A-Za-z0-9_À-ɏ])_([^\s_]|[^\s_][^_\n]*[^\s_])_(?![A-Za-z0-9_À-ɏ])/g

export const escapeHtml = text => String(text ?? '').replace(/[&<>"']/g, character => HTML_ESCAPES[character])

export const stripItalicUnderscores = text => String(text ?? '').replace(UNDERSCORE_ITALIC, '$1$2')

export default function formatMessageHtml(text) {
  return escapeHtml(text)
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    .replace(UNDERSCORE_ITALIC, '$1<em>$2</em>')
    .replace(/\n/g, '&nbsp;<br>')
}
